export default __webpack_public_path__ + "static/media/BLR-10.cdb0bdc4.JPG";